"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeRestrictionModal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
function AgeRestrictionModal({ age, message, }) {
    return age ? ((0, jsx_runtime_1.jsx)(ui_1.NoSSR, { children: (0, jsx_runtime_1.jsx)(AgeRestrictionModalComp, { age: age, message: message }) })) : null;
}
exports.AgeRestrictionModal = AgeRestrictionModal;
function AgeRestrictionModalComp({ age, message, }) {
    const { t } = (0, app_1.useTranslation)();
    const { back } = (0, app_1.useRouter)();
    const [ageConfirmation, setAgeConfirmation] = (0, app_1.useLocalStorage)('ageConfirmation');
    return !ageConfirmation || ageConfirmation < age ? ((0, jsx_runtime_1.jsx)(ui_1.Modal, Object.assign({ buttons: [
            { label: t('label.yes'), onClick: () => setAgeConfirmation(age) },
            { label: t('label.no'), onClick: back },
        ] }, { children: message || t('store.ageRestrictionModal.message', { age }) }))) : null;
}
